/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SubmitRiskBlockFeedbackRequestBody,
  SubmitRiskBlockFeedbackRequestBody$Outbound,
  SubmitRiskBlockFeedbackRequestBody$outboundSchema,
} from "../components/submitriskblockfeedbackrequestbody.js";

export type SubmitRiskBlockFeedbackSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type SubmitRiskBlockFeedbackRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  submitRiskBlockFeedbackRequestBody: SubmitRiskBlockFeedbackRequestBody;
};

/** @internal */
export type SubmitRiskBlockFeedbackSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SubmitRiskBlockFeedbackSecurity$outboundSchema: z.ZodMiniType<
  SubmitRiskBlockFeedbackSecurity$Outbound,
  SubmitRiskBlockFeedbackSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function submitRiskBlockFeedbackSecurityToJSON(
  submitRiskBlockFeedbackSecurity: SubmitRiskBlockFeedbackSecurity,
): string {
  return JSON.stringify(
    SubmitRiskBlockFeedbackSecurity$outboundSchema.parse(
      submitRiskBlockFeedbackSecurity,
    ),
  );
}

/** @internal */
export type SubmitRiskBlockFeedbackRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  SubmitRiskBlockFeedbackRequestBody:
    SubmitRiskBlockFeedbackRequestBody$Outbound;
};

/** @internal */
export const SubmitRiskBlockFeedbackRequest$outboundSchema: z.ZodMiniType<
  SubmitRiskBlockFeedbackRequest$Outbound,
  SubmitRiskBlockFeedbackRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    submitRiskBlockFeedbackRequestBody:
      SubmitRiskBlockFeedbackRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      submitRiskBlockFeedbackRequestBody: "SubmitRiskBlockFeedbackRequestBody",
    });
  }),
);

export function submitRiskBlockFeedbackRequestToJSON(
  submitRiskBlockFeedbackRequest: SubmitRiskBlockFeedbackRequest,
): string {
  return JSON.stringify(
    SubmitRiskBlockFeedbackRequest$outboundSchema.parse(
      submitRiskBlockFeedbackRequest,
    ),
  );
}
